import Profile from './ProfileContainer';

export { Profile };


// WEBPACK FOOTER //
// ./src/modules/home/profile/index.js